var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cloud-sort-button"},[_c('div',{class:{'arrow-down--small arrow-down--has-hover': _vm.isCollapsed, 'arrow-up--small arrow-up--has-hover': !_vm.isCollapsed},on:{"click":function($event){return _vm.$emit('click', $event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }